import {Divider, Stack, Table, TableBody, TableCell, TableRow, Typography, tableCellClasses} from "@mui/material";
import {TooltipProps} from "recharts/types/component/Tooltip";
import dayjs from "dayjs";

export const CHART_ITEM_HIDDEN_LABEL = "CHART_ITEM_HIDDEN";

export const BaseChartTooltip: React.FC<TooltipProps<number, string>> = ({active, payload, label}) => {
    if (active && payload?.length) {
        return (
            <Stack
                direction="column"
                padding="1rem"
                bgcolor="#FAFCFF"
                border={1}
                borderColor="#E9EBF1 !important"
                sx={{opacity: 0.9}}
            >
                <Typography>{formatTooltipLabel(label as Date)}</Typography>
                <Divider sx={{marginTop: "0.2rem", marginBottom: "1rem"}} />
                <Table size="small">
                    <TableBody
                        sx={{
                            [`& .${tableCellClasses.root}`]: {
                                borderBottom: "none",
                                paddingY: 0,
                                color: "#545A6E",
                                fontSize: 14,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                            },
                        }}
                    >
                        {payload
                            .filter((item) => item.name !== CHART_ITEM_HIDDEN_LABEL)
                            .map((item) => (
                                <TableRow key={item.dataKey}>
                                    <TableCell sx={{paddingLeft: 0}}>
                                        <Typography color={item.color}>
                                            {item.name}
                                            {item.unit && ` (${item.unit as string})`}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{paddingRight: 0}}>
                                        <Typography>
                                            {Array.isArray(item.value) ? item.value[item.value.length - 1] : item.value}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </Stack>
        );
    }

    return null;
};

const formatTooltipLabel = (tick: Date) => {
    return dayjs(tick).format("dddd, MMM D, YYYY").toUpperCase();
};
